import { createLogger, TRACE, stdSerializers, ConsoleFormattedStream } from "browser-bunyan";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const allStreams: any[] = [];

const conStream = {
  level: TRACE, // or use the string 'info'
  stream: new ConsoleFormattedStream(),
};
allStreams.push(conStream);

export const log = createLogger({
  name: "Termintool",
  level: TRACE,
  streams: allStreams,
  serializers: stdSerializers,
  src: false,
});

log.info("initialized logger");
